import Http from "../http";
import { Asset, Address, Snapshot, User } from "../models/wallet/mixin";

export default function(http: Http) {
  const mixin = {
    getAssets(): Promise<Asset[]> {
      return http.get("/mixin/wallet/assets");
    },

    getAsset(id: string): Promise<Asset> {
      return http.get(`/mixin/wallet/assets/${id}`);
    },

    getTopAssets() {
      return http.get(`/mixin/assets/top`);
    },

    searchAssets(str: string) {
      return http.get(`/mixin/assets/search/${str}`);
    },

    getSnapshots(params: {
      asset: string;
      limit?: number;
      offset?: string;
    }): Promise<Snapshot[]> {
      return http.get("/mixin/wallet/snapshots", { params });
    },

    getSnapshot(id: string): Promise<Snapshot> {
      return http.get(`/mixin/wallet/snapshots/${id}`);
    },

    getAssetAddresses(id: string): Promise<Address[]> {
      return http.get(`/mixin/wallet/assets/${id}/addresses`);
    },

    getAddress(id: string): Promise<Address> {
      return http.get(`/mixin/wallet/addresses/${id}`);
    },

    getUser(id: string): Promise<User> {
      return http.get(`/mixin/users/${id}/profile`);
    },

    searchUser(str: string) {
      return http.get("/mixin/search", { params: { q: str } });
    },

    verifyPayment(data) {
      return http.post("/mixin/payments/verify", { data });
    },

    getExternalTransactions(params: {
      destination?: string;
      tag?: string;
      asset?: string;
      limit?: number;
      offset?: string;
    }): Promise<External[]> {
      return http.get("/mixin/wallet/external_transactions", { params });
    }
  };

  return {
    mixin
  };
}
